import {
    mapAuthorForOne,
    mapSalesChannelsForOne,
    mapSalesChannelsForList,
    mapPlatformsForOne,
    mapProductsForOne,
    mapStatesForOne,
} from './common';

function mapPagesForOne(responseData) {
    if (!responseData.pages) {
        return { pages: [] };
    }

    // If pages is already an array, return it as-is
    if (Array.isArray(responseData.pages)) {
        return { pages: responseData.pages };
    }

    // If pages is a string, split it into an array
    if (typeof responseData.pages === 'string') {
        return {
            pages: responseData.pages.split(',').map((page) => page.trim()).filter(Boolean),
        };
    }

    // For any other type, return empty array
    return { pages: [] };
}

function mapGetOneHomeBannerData(responseData) {
    return {
        ...responseData,
        ...mapAuthorForOne(responseData),
        ...mapSalesChannelsForOne(responseData),
        ...mapPlatformsForOne(responseData),
        ...mapProductsForOne(responseData),
        ...mapStatesForOne(responseData),
        ...mapPagesForOne(responseData),
    };
}

function mapGetListHomeBannersData(responseData) {
    return responseData.map((data) => ({
        ...data,
        ...mapSalesChannelsForList(data),
    }));
}

export { mapGetOneHomeBannerData, mapGetListHomeBannersData };
